import { ComponentPropsWithoutRef } from "react";
import GradientBorderRadius from "./gradient-border-radius";
import clsx from "clsx";
import { IconComponent } from "./icon";

export type ExchangeName =
  | "uniswap"
  | "raydium"
  | "orca"
  | "meteora"
  | "pump"
  | "pumpAmm"
  | "launchlab"
  | "boop"
  | "fluxbeam";

export type ExchangeButtonProps = ComponentPropsWithoutRef<"button"> & {
  title: string;
  iconName: ExchangeName;
  onToggle: (name: ExchangeName) => void;
  active: boolean;
};

export const ExchangeButton = ({
  title,
  iconName,
  onToggle,
  active = false,
  ...rest
}: ExchangeButtonProps) => {
  return (
    <GradientBorderRadius
      hover="r-100"
      gradient="default-border"
      background={"default"}
      active={active ? "r-100" : "none"}
      className="h-[1.375rem]"
    >
      <button
        {...rest}
        className={clsx(
          rest?.className
            ? [rest.className, active && "bg-white/10"]
            : [
                "w-full h-full flex items-center justify-center gap-[0.3125rem]",
                active && "bg-gradient-to-r from-aqua/25 to-blue/25",
              ]
        )}
        onClick={(e) => {
          e.preventDefault();
          onToggle(iconName);
        }}
      >
        <IconComponent
          name={iconName}
          className="w-[0.75rem] h-[0.75rem] text-white"
        />
        {title}
      </button>
    </GradientBorderRadius>
  );
};
